import React from 'react'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import styled from 'styled-components/native'

import { AuthenticationButton } from 'features/auth/components/AuthenticationButton/AuthenticationButton'
import { StepperOrigin } from 'features/navigation/navigators/RootNavigator/types'
import { analytics } from 'libs/analytics/provider'
import { InternalTouchableLink } from 'ui/components/touchableLink/InternalTouchableLink'
import { ViewGap } from 'ui/components/ViewGap/ViewGap'
import { Button } from 'ui/designSystem/Button/Button'
import { Page } from 'ui/pages/Page'
import { UserFavorite } from 'ui/svg/icons/UserFavorite'
import { Spacer, Typo } from 'ui/theme'
import { setTextSemantic } from 'ui/theme/typographyAttrs/setTextSemantic'

export const NotConnectedFavorites = () => {
  const { bottom } = useSafeAreaInsets()

  const onBeforeSignupNavigate = () => {
    analytics.logSignUpFromFavorite()
    analytics.logSignUpClicked({ from: 'favorite' })
  }

  const onBeforeLoginNavigate = () => {
    analytics.logSignInFromFavorite()
  }

  return (
    <Page>
      <ScrollContainer bottom={bottom} showsVerticalScrollIndicator={false}>
        <MainContent>
          <IllustrationContainer>
            <Illustration />
          </IllustrationContainer>
          <TextContainer gap={4}>
            <StyledTitle2 {...setTextSemantic('h1')}>
              Identifie-toi pour retrouver tes favoris
            </StyledTitle2>
            <StyledBody {...setTextSemantic('h2')}>
              Ton compte te permettra de retrouver tous tes bons plans en un clin d’oeil&nbsp;!
            </StyledBody>
          </TextContainer>
          <ButtonContainer gap={4}>
            <InternalTouchableLink
              key={1}
              as={Button}
              wording="Créer un compte"
              navigateTo={{ screen: 'SignupMethods', params: { from: StepperOrigin.FAVORITE } }}
              onBeforeNavigate={onBeforeSignupNavigate}
              fullWidth
            />
            <StyledAuthenticationButton
              key={2}
              type="login"
              onAdditionalPress={onBeforeLoginNavigate}
              params={{ from: StepperOrigin.FAVORITE }}
            />
          </ButtonContainer>
        </MainContent>
        <Spacer.TabBar />
      </ScrollContainer>
    </Page>
  )
}

const ScrollContainer = styled.ScrollView.attrs<{ bottom: number }>(({ bottom }) => ({
  contentContainerStyle: {
    flexGrow: 1,
    alignItems: 'center',
    paddingBottom: bottom,
    height: '100%',
    justifyContent: 'center',
  },
}))<{ bottom: number }>(({ theme }) => ({
  paddingHorizontal: theme.contentPage.marginHorizontal,
  paddingVertical: theme.contentPage.marginVertical,
}))

const MainContent = styled.View({
  width: '100%',
  alignItems: 'center',
})

const IllustrationContainer = styled.View(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.designSystem.size.spacing.xl,
}))

const Illustration = styled(UserFavorite).attrs(({ theme }) => ({
  size: theme.illustrations.sizes.fullPage,
  color: theme.designSystem.color.icon.brandPrimary,
}))``

const ButtonContainer = styled(ViewGap)(({ theme }) => ({
  maxWidth: theme.contentPage.maxWidth,
  width: '100%',
  alignContent: 'center',
}))

const StyledAuthenticationButton = styled(AuthenticationButton).attrs(({ theme }) => ({
  linkColor: theme.designSystem.color.text.brandSecondary,
}))``

const TextContainer = styled(ViewGap)(({ theme }) => ({
  alignItems: 'center',
  marginBottom: theme.designSystem.size.spacing.xxxxl,
}))

const StyledTitle2 = styled(Typo.Title2)({
  textAlign: 'center',
})

const StyledBody = styled(Typo.Body)({
  textAlign: 'center',
})
